<div class="wrapper">
  <div class="info">
    <span class="title">{{ "deals.orderSummary" | translate }}</span>
    <div>
      <span>{{ "deals.orderNumber" | translate }}: </span>
      <span>{{ transaction.transactionId }}</span>
    </div>

    <div *ngIf="checkComment()">
      <span>{{ "deals.comment" | translate }}: </span>
      <span class="comment">{{ checkComment() }}</span>
    </div>

    <div class="total">
      <span>{{ "deals.totalAmount" | translate }}: </span>
      <span>{{ transaction?.amount }} AMD</span>
    </div>
  </div>

  <div class="pay">{{ "deals.paid" | translate }}</div>

  <div
    class="email-wrapper"
    [formGroup]="emailFormControl"
    *ngIf="!showSuccessMsg; else successMsgTemplate"
  >
    <span>{{ "deals.sendWithEmail" | translate }}</span>
    <div class="email">
      <input
        type="email"
        placeholder="{{ 'deals.mail' | translate }}"
        formControlName="email"
        [ngClass]="{ invalid: emailFormControl.invalid }"
      />
      <button [disabled]="emailFormControl.invalid" (click)="onEmailSend()">
        <ng-container *ngIf="!isLoading; else loaderTemplate">
          {{ "deals.send" | translate }}
        </ng-container>
      </button>
    </div>
  </div>
</div>

<ng-template #loaderTemplate>
  <div
    style="
      padding: 5px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <div class="loader"></div>
  </div>
</ng-template>

<ng-template #successMsgTemplate>
  <div class="pay msg">
    {{ "deals.emailsend" | translate }}
  </div>
</ng-template>
